<script>
  import { navigationStore } from "../../stores/navigationStore";
  import viewport from "../../actions/useViewport";

  export let headerText = "";
  export let text = "";
</script>

<section
  id="about"
  use:viewport
  on:enterViewport={() => navigationStore.changeActiveItem("about")}
>
  <div class="idea-img">
    <img src="./assets/images/idea.png" alt="Idea" />
  </div>

  <h1>{headerText}</h1>
  <p>
    {text}
  </p>
</section>

<style>
  section {
    position: relative;
    width: 1440px;
    height: 660px;
    left: -32px;
    top: 80px;
  }

  .idea-img {
    position: absolute;
    width: 132px;
    height: 132px;
    left: 654px;
    top: 110px;
  }

  h1 {
    position: absolute;
    width: 367px;
    white-space: nowrap;
    left: 546px;
    top: 285px;

    font-style: normal;
    font-weight: 800;
    font-size: 36px;
    line-height: 49px;
    text-align: center;
    color: var(--primary-color);
  }

  p {
    position: absolute;
    max-width: 367px;
    left: 546px;
    top: 354px;

    font-family: Nunito Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 190%;

    /* or 30px */
    text-align: center;

    /* Gray */
    color: #6e6e6e;
  }

  @media (max-width: 1300px) {
    /* Tablets */

    section {
      width: 100%;
      height: 485px;
      margin-top: 136px;
      padding: 0 16px;
      left: 0;
      top: 0;

      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .idea-img {
      position: static;
      margin-top: 22px;
      margin-bottom: 34px;
    }

    h1 {
      position: static;
      font-size: 32px;
    }

    p {
      margin-top: 12px;
      position: static;
      font-size: 16px;
      text-align: center;
    }
  }

  @media (max-width: 650px) {
    section {
      width: 100%;
      height: 475px;
      margin-top: 336px;
      padding: 0 16px;

      top: 0;
      left: 0;

      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .idea-img {
      position: static;
      margin-top: 22px;
      margin-bottom: 34px;
    }

    h1 {
      position: static;
      font-size: 28px;
    }

    p {
      margin-top: 12px;
      position: static;
      font-size: 16px;
      text-align: center;
    }
  }
</style>
